import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getAllSourcePricMemo } from '../../../common/endpoints';

export const getAllSourcePriceMemoData = createApi(getAllSourcePricMemo, 'GET');

const GetAllSourcePriceMemo = createSlice({
  name: 'GetAllSourcePriceMemo',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllSourcePriceMemoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllSourcePriceMemoData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllSourcePriceMemoData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAllSourcePriceMemo.reducer;